export type FireDataType =
  | 'wfigs-fires'
  | 'firms-hotspots'
  | 'nps-restrictions'
  | 'usfws-restrictions'

export const ALL_FIRE_TYPES: FireDataType[] = [
  'wfigs-fires',
  'firms-hotspots',
  'nps-restrictions',
  'usfws-restrictions',
]

export interface FireLayerMeta {
  type: FireDataType
  label: string
  color: string
  icon: string
}

export const FIRE_LAYER_META: Record<FireDataType, FireLayerMeta> = {
  'wfigs-fires': {
    type: 'wfigs-fires',
    label: 'Active Wildfires',
    color: '#dc2626',
    icon: 'local_fire_department',
  },
  'firms-hotspots': {
    type: 'firms-hotspots',
    label: 'Fire Detections (FIRMS)',
    color: '#fbbf24',
    icon: 'whatshot',
  },
  'nps-restrictions': {
    type: 'nps-restrictions',
    label: 'Fire Restrictions',
    color: '#ea580c',
    icon: 'warning',
  },
  'usfws-restrictions': {
    type: 'usfws-restrictions',
    label: 'Fire Restrictions',
    color: '#d97706',
    icon: 'warning',
  },
}
